var version = {
    "name":      "dativery",
    "buildDateCode": "20260109-111106",
    "buildDate": "Fri Jan 09 2026 11:11:06 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260109-111106",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;